import { isNumber } from "lodash"
import { VALUE_FORMATS } from "helpers/ai"
import { numberFormatter, makeCurrencyFormatter } from "helpers/formatters/numbers"

export function parseValue(value, format) {
  if (value == null) {
    return isNumberFormat(format) ? null : ""
  }

  if (!isNumber(value) && format !== VALUE_FORMATS.STRING) {
    const numericValue = parseFloat(value)
    if (isNaN(numericValue)) {
      return isNumberFormat(format) ? null : value
    }
    return numericValue
  }

  return value
}

export function formatValueForDisplay(value, format, currency) {
  const parsedValue = parseValue(value, format)
  if (parsedValue === null || parsedValue === "") {
    return parsedValue
  }

  switch (format) {
    case VALUE_FORMATS.PERCENT_100:
      return numberFormatter(parsedValue * 100)
    case VALUE_FORMATS.PERCENT_10000:
      return numberFormatter(parsedValue * 10000)
    case VALUE_FORMATS.PERCENT:
      return numberFormatter(parsedValue)
    case VALUE_FORMATS.NUMBER:
      return numberFormatter(parsedValue)
    case VALUE_FORMATS.CURRENCY:
      return makeCurrencyFormatter(currency)(parsedValue)
    case VALUE_FORMATS.STRING:
    default:
      return parsedValue
  }
}

export function isNumberFormat(format) {
  return [
    VALUE_FORMATS.PERCENT,
    VALUE_FORMATS.PERCENT_100,
    VALUE_FORMATS.PERCENT_10000,
    VALUE_FORMATS.NUMBER,
    VALUE_FORMATS.CURRENCY,
  ].includes(format)
}

export function getColumnType(format) {
  return isNumberFormat(format) ? "number" : "string"
}
